export default "__VITE_ASSET__CgAV9mgR__"